import React, { useEffect, useState } from "react";

const DocumentPreview = ({ fileUrl, zoom, setZoom }) => {
    const [pdfSrc, setPdfSrc] = useState(null);

    useEffect(() => {
        if (!fileUrl || !fileUrl.match(/\.pdf$/i)) return;

        let isMounted = true;
        let objectUrl = null;

        const loadPdf = async () => {
            const response = await fetch(fileUrl, { credentials: "include" });
            if (!response.ok) { throw new Error("Failed to load PDF"); }
            const blob = await response.blob();
            objectUrl = URL.createObjectURL(blob);
            if (isMounted) { setPdfSrc(objectUrl); }
        };

        loadPdf().catch(console.error);
        return () => {
            isMounted = false;
            if (objectUrl) { URL.revokeObjectURL(objectUrl); }
        };
    }, [fileUrl]);

    const isImage = fileUrl?.match(/\.(jpeg|jpg|png)$/i);

    return (
        <div style={styles.left}>
            {isImage && (
                <div style={styles.zoomControls}>
                    <button onClick={() => setZoom(z => z + 0.2)}>+</button>
                    <button onClick={() => setZoom(z => Math.max(0.5, z - 0.2))}>-</button>
                </div>
            )}

            <div style={styles.previewWrapper}>
                {isImage && (
                    <img
                        src={fileUrl}
                        alt="invoice"
                        style={{
                            maxWidth: "100%",
                            transform: `scale(${zoom})`,
                            transformOrigin: "top center",
                        }}
                    />
                )}

                {pdfSrc && (
                    <embed
                        src={`${pdfSrc}#zoom=${zoom * 70}`}
                        title="application/pdf"
                        style={styles.iframe}
                    />
                )}
            </div>
        </div>
    );
};

const styles = {
    left: {
        flex: 1,
        background: "#111",
        color: "#fff",
        position: "relative",
        overflow: "hidden",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
    },

    zoomControls: {
        position: "sticky",
        top: 0,
        zIndex: 10,
        display: "flex",
        gap: "10px",
        padding: "12px",
        background: "#111",
        borderBottom: "1px solid #333",
    },

    previewWrapper: {
        flex: 1,
        overflow: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "10px",
    },

    iframe: {
        width: "100%",
        height: "95vh",
        border: "none",
        borderRadius: "8px",
        background: "#fff",
    },
};

export default DocumentPreview;
